export default __webpack_public_path__ + "static/media/wheel1.eb53bc50.png";